import React, { Component } from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import numeral from 'numeral'
import Dropzone from 'react-dropzone'
import { toast } from 'react-toastify'

import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'




import {
    closeDocumento,
    updateInputs,
    uploadFirmasFile,
    showHideModalAddFirmas,
} from '../../actions/contratoanual'


import { acceptedFiles } from '../../utils/helpers'
const filesTypes = acceptedFiles.map(x => x.type).join()

class ModalAddFirmas extends Component {

    handleCloseModal = () => {
        const modal = document.getElementById('modalAddFirmas')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalAddFirmas .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        setTimeout(() => this.props.showHideModalAddFirmas(false), 300)
    }

    handleOnDrop = (files) => {
        if (files.length > 1) {
            toast.warn(`Solo es permitido procesar un archivo a la vez`, { bodyClassName: 'toastify-content toastify-warning' })
            return
        }
        this.props.uploadFirmasFile(files[0])
    }

    handleOnRejected = (files) => {
        files.forEach(x => {
            toast.warn(`El archivo ${x.name} no es del tipo esperado. ${x.type}`, { bodyClassName: 'toastify-content toastify-warning' })
        })
    }

	setIcon = (icon) => {
		if (icon) {
			const imageSrc = require('../../img/16px/' + icon)
			return <img src={ imageSrc } />
		}
		return null
    }
    

    handleSave = (e) => {

        this.props.closeDocumento()
        this.handleCloseModal(e, "modalAddFirmas")

    }

    render() {

        const { modalAddFirmas } = this.props
        if (!modalAddFirmas.get('show')) {
            return null
        }

        return(
            <Modal id="modalAddFirmas" show={ true } ZIndex={ 2000 }>
                <ModalHeader title={ `Subir contrato firmado` } onClose={ e => this.handleCloseModal(e, "modalAddFirmas") } />
                <ModalButtonStrip>
                    <BoxButton
                        name="floppy-o"
                        title="Guardar"
                        onClick={ e => this.handleSave(e) }
                        disabled = { (modalAddFirmas.getIn(['data', 'file']) && (modalAddFirmas.getIn(['data', 'file']).size != 0)) ? false : true }
                    />
                </ModalButtonStrip>
                <ModalBody>
                    <div style={{ width: '600px' }}>
						<div className="row">
							<div className="col-md-12">
                                <Dropzone accept={ filesTypes } onDropAccepted={ this.handleOnDrop } onDropRejected={ this.handleOnRejected } className="dropzone1">
                                    <p>Arrastre el documento escaneado con las firmas a esta sección</p>
                                </Dropzone>
							</div>
						</div>
						<div className="row" style={{ marginTop: '10px' }}>
							<div className="col-md-12">
								<div className="form-group">
									<label className="control-label">Nombre del archivo</label>
									<div className="div-input-sm">
										{
											(modalAddFirmas.getIn(['data', 'file']) &&
												<div style={{ paddingTop: '1px' }}>
													<span>{ this.setIcon(modalAddFirmas.getIn(['data', 'icono'])) }</span>
													<span style={{ marginLeft: '4px', verticalAlign: 'bottom' }}>{ modalAddFirmas.getIn(['data', 'file']).name }</span>
													<span style={{ marginLeft: '3px', verticalAlign: 'bottom', color: '#ccc' }}>({ numeral(modalAddFirmas.getIn(['data', 'file']).size).format('0.0 b') })</span>
												</div>
											)
										}
									</div>
								</div>
							</div>
						</div>
                        <div className="row">
                            <div className="col-md-12">
								<div className="form-group">
									<label className="control-label">Observaciones</label>
									<textarea className="form-control input-sm" rows={4} value={ modalAddFirmas.getIn(['data', 'observaciones']) || '' } disabled />
								</div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalAddFirmas: state.contratoanual.get('modalAddFirmas'),
        createDocumento: state.contratoanual.get('createDocumento'),
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        showHideModalAddFirmas: (show) => dispatch(showHideModalAddFirmas(show)),
		updateInputs: (path, value, immutable) => dispatch(updateInputs(path, value, immutable)),
        uploadFirmasFile: (file) => dispatch(uploadFirmasFile(file)),
        closeDocumento: () => dispatch(closeDocumento()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalAddFirmas)


// WEBPACK FOOTER //
// ./src/components/ContratoAnual/ModalAddFirmas.jsx